import { ChangeDetectionStrategy, Component, EventEmitter, Output, input, linkedSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface Face {
  value: number;
  emoji: string;
  labelKey: string;
}

export const RATING_FACE_EMOJI: Record<number, string> = {
  5: '😄',
  4: '🙂',
  3: '😐',
  2: '🙁',
  1: '😠',
};

const FACES: Face[] = [
  { value: 5, emoji: RATING_FACE_EMOJI[5], labelKey: 'support_popup.case.lbl_rating_face_5' },
  { value: 4, emoji: RATING_FACE_EMOJI[4], labelKey: 'support_popup.case.lbl_rating_face_4' },
  { value: 3, emoji: RATING_FACE_EMOJI[3], labelKey: 'support_popup.case.lbl_rating_face_3' },
  { value: 2, emoji: RATING_FACE_EMOJI[2], labelKey: 'support_popup.case.lbl_rating_face_2' },
  { value: 1, emoji: RATING_FACE_EMOJI[1], labelKey: 'support_popup.case.lbl_rating_face_1' },
];

@Component({
  selector: 'app-face-rating',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './face-rating.component.html',
  styleUrls: ['./face-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaceRatingComponent {
  value = input<number | null>(null);
  disabled = input<boolean>(false);

  @Output() rating = new EventEmitter<number>();

  faces = FACES;
  selectedValue = linkedSignal(() => this.value());

  onSelect(faceValue: number): void {
    if (this.disabled()) return;
    this.selectedValue.set(faceValue);
    this.rating.emit(faceValue);
  }
}
